import './TipOfTheDay.css';
import { LightbulbIcon } from 'components/icons/LightbulbIcon';
import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const TipOfTheDay: FC<Props> = ({ children }) => (
  <div className='tip-of-the-day'>
    <div className='tip-of-the-day__lightbulb'>
      <LightbulbIcon title={null} />
    </div>
    <div>{children}</div>
  </div>
);
